import type { ITheme } from '../../../utils/theme';

export const getStyledAriaSelectColor = (
  isDirty: boolean,
  hasError: boolean,
  theme: ITheme
): string => {
  return hasError && isDirty
    ? theme.palette.error.main
    : theme.palette.neutral['100'];
};
